<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202408_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202408_01_sp.jpg" class="only_sp" />
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">美肌菌に特化した美容液<br>『フローラ ファーストセラム』人気の理由</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">FIRST SERUM</h3>
        <p class="mb-3">「フローラ」ラインのお手入れ第一歩は、洗顔直後の角層へアプローチする【美肌菌に特化した美容液】「ファーストセラム」。</p>
        <p>美肌菌の働きと皮膚常在菌のバランスに着目して開発。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202408_02.jpg">
      </div>
    </div>

    <h2 class="mt-5 pt-5">【製品説明】<br>
    肌をととのえながら、<br>肌みずからうるおいを保つ力をサポートする<br>
    マナビスオリジナル処方<br>「スキンバランシングフォーミュラF（整肌）」</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202408_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">乳酸菌生産物質で「美肌菌が喜ぶ環境」を作り、フルーツコンプレックスM*で「皮膚常在菌に適した環境」を作り出しています。</p>
        <h3 class="mb-3">これがオンリーワンの<br>「スキンバランシングフォーミュラF」</h3>
        <p>*グレープフルーツ果実エキス、グレープフルーツ種子エキス、ナツメ果実エキス、リンゴ果実エキス、サンザシエキス、ライム果汁、オレンジ果汁、レモン果汁（すべて整肌成分）</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">【主要成分】</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left">
        <h3 class="mb-3">乳酸桿菌/豆乳発酵液</h3>
        <p class="mb-3">特殊な豆乳を発酵させた乳酸桿菌/豆乳発酵液は、菌の専門家の処方による発酵エキス。</p>
        <p>アミノ酸、ペプチドをはじめとした409種類の多様な成分を含み、肌に潤いとツヤを与えます。</p>
      </div>
      <div class="feature-row_item_image">
        <img src="@/assets/img/column/202408_04.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image">
        <img src="@/assets/img/column/202408_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right">
        <h3 class="mb-3">コメ発酵液</h3>
        <p class="mb-3">お米を菌のチカラで発酵させ、抽出したものです。</p>
        <p>水分を保持する能力があり、お肌の水分蒸発を防ぎ、肌荒れを防ぎ、しっとりみずみずしい素肌に導きます。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">知ってほしい、美肌菌の必要性</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202408_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <h3 class="mb-3">必要な皮膚常在菌まで取り去ってしまってる？</h3>
        <p class="mb-3">マナビス化粧品は、美肌菌とも呼ばれる 皮膚常在菌 に着目。</p>
        <p class="mb-3">鏡を見たり、肌にふれたりするだけでは気づきませんが、それは、すこやかさのカギを握る大切な存在なのです。</p>
        <p class="mb-3">また、どのような皮膚常在菌が、どのようにバランスを保っているのか、それぞれの肌で違っていることもわかってきました。</p>
        <p class="mb-3">メイクアップを落とすクレンジングは、必要な皮脂や皮膚常在菌まで取り去ってしまいます。</p>
        <p>また、必要なうるおいをきちんと残すタイプの洗顔料も、皮膚常在菌の一部を洗い流してしまうことがあります。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">美容皮膚科医も重要という「美肌菌」</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202408_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <p class="mb-3">そんな、お肌にとって貴重な「美肌菌」。</p>
        <p class="mb-3">実は美容皮膚科医の約9割がお肌にとって重要と回答しています。</p>
        <p class="mb-3">ところがアンケートの結果、女性の約6割が、その「美肌菌」を知らないということが明らかになりました。</p>
        <p>しかし近年、美容マニアを中心に一般の方まで、幅広く注目されだしています。</p>
      </div>
    </div>

    <div class="layer_01 mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        ずっと素肌に自信を持っていたいから
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">お客様の声</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202408_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75">
        <h3 class="mb-3">ピックアップレビュー</h3>
        <p class="mb-3">・パサパサのお肌が少ししっとりした気がします。（20代）</p>
        <p class="mb-3">・洗顔後にお顔に使う美容液です。馴染みのよい、少しとろみのある使用感です。美肌菌に適した環境を保ってくれるので、自分のお肌力が上がります。その後に使うお化粧品がよく浸透している気がします。（30代）</p>
        <p class="mb-3">・ファーストセラムを初めて使いました。化粧水とどうちがうのかなと思ってましたが、スゥーッと浸透していきました。普段は他社の美容液を使っていますが、ファーストセラムを使った方がなじみやすいです。美肌菌と皮膚常在菌がいい仕事をしてくれそうな気がします。 （40代）</p>
        <p>・今、TikTokやInstagramでバズっていて気になっていたマナビス化粧品を発見したので早速サンプルを申し込み。ファーストセラムを使った後の化粧水や乳液の浸透感がスゥーッと入って気持ち良い。数日続けたところ、明らかに肌が潤いを増したし、明るい印象になって調子が良い。敏感肌なので信頼の日本製はやっぱり肌に合うなと実感しました。感動したので、長文レビュー。買います！ （30代）</p>
      </div>
    </div>
    
    <div class="feature-row feature-row_voice_list pb-0">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>美肌菌に適した環境を作るサポートの為の美容液とのことで気になりお試ししました。普段から美容液は使用しているのですが、普段よりその後のステップのなじみが良い気がしました。</p>
        <p>（30代）</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>サラッとした美容液で香りもゆずの匂いに癒されます。化粧水の前に使用しますが、さすが！浸透力が高いのかその後の化粧水が普段よりもぐんっと入った気がします。</p>
        <p>（20代）</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>少しとろっとした使い心地。すごくお肌に入り込む感じがします。洗顔後の乾いたお肌になじむ感じが良いです。美肌菌の為になってくれる事を願いながら４回分のサンプルを試し終えたところです。使い終えた感想は若干肌が柔らかくなったような気がします。ほんのりゆずの香りが自己主張せずに気持ちいい～。</p>
        <p>（30代）</p>
      </div>
    </div>
    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>す～っとなじむようなサラッとした感触です。匂いは控えめで柑橘系です。</p>
        <p>（30代）</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>手に取った感じはサラサラとした感じですが、塗るとものすごく伸びて顔全体にいきわたる感じがして良かったです。そのあとの化粧水や乳液がぐんぐんなじんでいくような気がしてその日一日、気持ち良く過ごすことが出来ました。</p>
        <p>（50代）</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
          </div>
        <p>美容液にゆずの香りはかなり珍しいと思いますが、とてもリフレッシュでいい香りでした。</p>
        <p>（30代）</p>
      </div>
    </div>
    
    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202408_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75">
        <h3 class="mb-3">スタッフの体験談をご紹介</h3>
        <p class="mb-3">マナビス化粧品 スタッフ40代</p>
        <p class="mb-3">入社当初は肌で悩んでいて人前に出ることがとても嫌で、誰とも会いたくなくて・・。鏡を見るのも嫌で、インスタなどのSNSでキラキラしている人がうらやましかったです。</p>
        <p class="mb-3">その後、ファーストセラムを使用するようになってから、肌を褒められることが多くなり、人前に出る事やメイクをするのも楽しくなりました。今では、高島屋さんとマナビス化粧品のコラボインスタライブにまで、自信を持って出演できるようになりました。</p>
        <p><strong>インスタライブは<a href="https://www.instagram.com/reel/C7wGLztyN5P/?igsh=MWw0NWl0ZWRmZGNydA==" target="_blank">こちら</a>からアーカイブをご覧いただけます。</strong></p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">メディアでも注目いただいている<br>「フローラ ファーストセラム」</h2>
    <div class="video-wrapper"><iframe src="https://www.youtube.com/embed/JpDnCAVI_p0?rel=0&amp;showinfo=0&amp;vq=720" width="100%" height="100%" frameborder="0" allowfullscreen=""></iframe></div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left">
        <h3 class="mb-3">FLORA<br>フローラ ファーストセラム</h3>
        <p class="mb-3">¥7,700</p>
        <p class="mb-3">美肌菌に特化した美容液 40mL</p>
        <p class="mb-3">朝晩3プッシュずつ</p>
        <p class="mb-3">昼用 夜用</p>
        <p>すこやかさのカギを握る美肌菌と<br>皮膚常在菌のバランスに着目した、<br>洗顔後すぐに使う美肌菌に特化した美容液。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image">
        <img src="@/assets/img/column/202408_02.jpg">
      </div>
    </div>
   
    <div class="layer_02">
      <img src="@/assets/img/column/202408_10.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <p class="mb-3">FLORA</p>
          <p>菌に着目したバランシングケア</p>
        </div>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">FLORAシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/flora_firstserum.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">フローラ ファーストセラム</div>
              <div class="feature-row_product_cate">FLORA</div>
              <div class="feature-row_product_price">¥7,700</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/flora_skincareoil.jpg">
          <div class="feature-row_product_detail text-center">
            <div class="feature-row_product_title">フローラ スキンケアオイル</div>
            <div class="feature-row_product_cate">FLORA</div>
            <div class="feature-row_product_price">¥7,700</div>
          </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/flora_supplementbasic.jpg">
          <div class="feature-row_product_detail text-center">
            <div class="feature-row_product_title">フローラ サプリメント ベーシック</div>
            <div class="feature-row_product_cate">FLORA</div>
            <div class="feature-row_product_price">¥6,300</div>
          </div>
        </router-link>
      </div>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

.video-wrapper {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  padding-bottom: 56.25%;
  height: auto;
}
.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
  font-size: 1.8em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202408_10.jpg');
      background-size: cover;
      min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
   .img-top-slide_text {
      top: 40%;
      left: 15px;
      right: 15px;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_01 {
    min-height: 300px;
  }
  .layer_01 .layer-text {
    font-size: 1.4em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>